var exports = {
  "Gf": "FriendsListSection.module__sectionTitle___LUMweG",
  "f5": "FriendsListSection.module__sectionContent___LUMweG",
  "v2": "FriendsListSection.module__sectionContentWithMargin___LUMweG",
};

module.exports = exports;
